import dayjs from 'dayjs'

import { parseDateFormatString } from './parseDateFormatString'
import type { Timeframe } from './timeframe'
//
// 2021-01のような文字列を解析して、startAt, endAtを返す関数
// 例えば、2021-01に対しては、startAt: 2021-01-01, endAt: 2021-01-31の値を返す（実際の値はdayjsのインスタンス）
// 2021-1Q, 2021-01-01Wのような四半期、週のような特殊な日付け意識に対応しているのが特徴
//
export function parseDateFormatStringAsRange(
  dateString: string,
  option?: { accountClosingMonth?: number; weekOffset?: number; timeframe?: Timeframe },
) {
  const detected = parseDateFormatString(dateString)
  if (detected === undefined) {
    return undefined
  }

  const timeframe = detected.timeframe
  switch (timeframe) {
    case 'day': {
      const startAt = detected.date
      return {
        startAt,
        endAt: startAt,
      }
    }
    case 'week': {
      // return dayjs(dateString)
      return undefined // TODO
    }
    case 'month': {
      const startAt = detected.date
      return {
        startAt,
        endAt: startAt.endOf('month'),
      }
    }
    case 'fiscal_quarter': {
      const result = /(\d\d\d\d)-(\d)Q/.exec(dateString)
      const year = result?.[1]
      const quarter = result?.[2]
      if (year === undefined || quarter === undefined) {
        return undefined
      }
      if (!['1', '2', '3', '4'].includes(quarter)) {
        return undefined
      }
      // 決算月が3月のとき、3ヶ月加えて4月始まりが正しい
      // yearが2022、決算月が12月のとき、2022-1Qは1月。
      const quarterStartAt = dayjs(`${year}-01-01`).add((option?.accountClosingMonth ?? 0) % 12, 'month')
      const startAt = quarterStartAt.add((parseInt(quarter) - 1) * 3, 'month')
      return {
        startAt,
        endAt: startAt.add(2, 'month').endOf('month'),
      }
    }
    case 'year': {
      const yearStartAt = detected.date
      if (option?.timeframe === 'fiscal_year' && option.accountClosingMonth !== undefined) {
        const startAt = yearStartAt.add(option.accountClosingMonth % 12)
        return {
          startAt,
          endAt: startAt.endOf('year'),
        }
      }
      const startAt = yearStartAt
      return {
        startAt,
        endAt: startAt.endOf('year'),
      }
    }
    default: {
      const x: never = timeframe
      return undefined
    }
  }
}
